import { useLingui } from '@lingui/react/macro';
import React, { useCallback } from 'react';
import history from 'modules/overlay-canvas/addons/history';
import UDText from 'ud-ui/components/text';
import Selector from 'modules/template-editor/ui/components/elements/selector';
import { useEditorManager } from 'modules/template-editor/ui/context';

interface IProps {
  onChange: (teamIndex: 0 | 1) => void;
  value: 0 | 1;
}

function ChoosingTeam(props: IProps) {
  const { t } = useLingui();
  const options = [
    { label: t`Команда №1`, value: 0 },
    { label: t`Команда №2`, value: 1 },
  ];
  const { onChange, value } = props;
  const manager = useEditorManager();

  const onFocusField = useCallback(() => {
    manager?.render();
    history.saveState();
  }, [manager]);

  return (
    <>
      <UDText type={'caption-1'}>{t`Команда`}</UDText>
      <Selector
        onFocus={onFocusField}
        styledEachOption
        onChange={(event) => {
          onChange(event?.value);
        }}
        options={options}
        value={options.find((option) => option.value === value)}
      />
    </>
  );
}

export default ChoosingTeam;
